import { render, staticRenderFns } from "./InviteSpectator.vue?vue&type=template&id=6c80f748&scoped=true&"
import script from "./InviteSpectator.vue?vue&type=script&lang=js&"
export * from "./InviteSpectator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80f748",
  null
  
)

export default component.exports